<!-- <div ></div> -->
<ng-container *ngIf="!showCode">
    <!--    <h1 >{{'WELCOME_BACK_TITLE' | translate}}</h1>-->
    <!--    <h2 class="mb30">{{username}}</h2>-->
    <!--  custom-->
    <span class="custom-login-info">Passwort zurücksetzen</span>
    <p style="margin-top: 15px; color: #505456">Sie haben Ihr Passwort vergessen? Nach Klick auf den untenstehenden Link erhalten Sie umgehend eine
        E-Mail mit einem Verifizierungscode, über den Sie Ihr Passwort ändern können.<br><br></p>
    <!-- <div *cidContentLoader="contentLoading"></div> -->
    <div class="mb30">
        <app-button (clickEvent)="initiateReset()" [btnOption]="buttonOptions.resetButtonOption" [loading]="contentLoading" class="login-btn">
        </app-button>
        <div class="mat-error" *ngIf="errorMessage">
            {{errorMessage | translate}}
        </div>
    </div>

    <!--    <a [routerLink]="[]" (click)="backToInitiate()">{{'BACK' | translate}}</a>-->
</ng-container>

<ng-container *ngIf="showCode">
    <!--  custom-->
    <span class="custom-login-info">Passwort zurücksetzen</span>
    <p style="margin: 15px 0 25px 0; font-size: 16px; color: #505456;">
        Es wurde ein Verifizierungscode an Sie per E-Mail gesendet. Fügen Sie den Code ein, um Ihr Passwort zurückzusetzen.
    </p>
    <div class="verifycode full-width">
        <app-input-group [options]="inputGroupOption" (btnEvent)="submitCode()" (inputEvent)="updateCode($event)" [inputLoading]="submissionInProgress">
        </app-input-group>
    </div>
    <div *ngIf="showBack" class="mb30 cancel-button">
        <a [routerLink]="[]" (click)="backToInitiate()">{{'CANCEL' | translate}}</a>
    </div>
    <div *ngIf="!showBack" class="mb30 cancel-button">
        <a [routerLink]="[]" (click)="backToInitiate()">{{'BACK' | translate}}</a>
    </div>
    <div class="mat-error">
        {{errorMessage | translate}}
    </div>
</ng-container>
